module.exports = __webpack_public_path__ + "img/add-to-chat.6fafdfe7.png";